module.exports = __webpack_public_path__ + "img/9788991931657.f570f678.jpg";